// extracted by mini-css-extract-plugin
module.exports = {"totpField":"SecondFactorTOTP_totpField__OMT0y","totpButton":"SecondFactorTOTP_totpButton__sFSHf","registerDeviceContainer":"SecondFactorTOTP_registerDeviceContainer__10qdr"};